import { createContext, useContext } from 'react';

import { TUserUiPreferencesApi } from '@/shared/features/user-ui-preferences/context/user-ui-preferences-api-context.types';
import {
  useReadUserUiPreferencesQuery,
  useUpdateUserUiPreferencesMutation,
} from '@/shared/redux/api/ident/enhanced-ident-api';

// Defaults to the console's ident API, so Classic and Modern need no provider; Backoffice provides its super-user API.
export const UserUiPreferencesApiContext = createContext<TUserUiPreferencesApi>(
  { useReadUserUiPreferencesQuery, useUpdateUserUiPreferencesMutation },
);

export const useUserUiPreferencesApi = () =>
  useContext(UserUiPreferencesApiContext);
